export enum DsLinearWorkTypesEnum {
  MAIN_SECTION = 1,
  LINEAR_ANNEX = 2,
  PUNCTUAL_ANNEX = 3,
}
